import React, { useState, useCallback } from "react";
import { Grid, Loader, Checkbox, Icon, Segment, Header, Statistic, Message, Button, List, Modal, Label, Responsive } from "semantic-ui-react";
import HelpFolderListItem from "features/Admin/HelpNurses/components/HelpFolderListItem";
import CustomPagination from "components/CustomPagination";
import HistoricNurseHelpModal from "../../../components/Others/HistoricNurseHelpModal";
import moment from "moment";
import { useSafePolling } from "hooks/useSafePolling";
import CampaignPatientMatchingModal from "./CampaignPatientMatchingModal";
import DatePicker from "react-datepicker";
import PreregisterListItem from "features/Admin/HelpNurses/components/PreregisterListItem";
import Select from "react-select";
import ExpressList from "./ExpressList";
import AudioNotificationModal from "./Modals/AudioNotificationModal";
import MyTelForTvSecModal from "./Modals/MyTelForTvSecModal";
import LastFoldersSupportedModal from "./Modals/LastFoldersSupportedModal";

const _tvsecContainer = (my) => ({
	backgroundColor: !my ? "#43b39e" : "orange",
	width: "100%",
	position: "relative",
	padding: 10,
	display: "flex",
	borderRadius: "4px 4px 0 0",
	marginTop: "5px",
	boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
	alignItems: "baseline",
});
const styles = {
	icon: { color: "#fff", fontSize: "1.5em" },
	dateText: { color: "white", marginRight: 5, marginLeft: 5 },
	select: {
		container: (provided) => ({
			...provided,
			width: "250px",
			cursor: "pointer",
			margin: "5px 0",
			fontSize: "0.8em",
			color: "teal",
			height: 38,
			paddingRight: 10,
		}),
		option: (provided) => ({
			...provided,
			cursor: "pointer",
			fontSize: "0.9em",
			textAlign: "left",
		}),
		control: (provided) => ({
			...provided,
			cursor: "pointer",
		}),
	},
};
const isMobile = () => {
	return window.innerWidth - Responsive.onlyMobile.maxWidth < 0;
};

const TvSecretariat = ({
	isLoading,
	folderHelps,
	preregister,
	changePreregister,
	done,
	totalFolderHelps,
	goToFolderManager,
	changeDone,
	pagination,
	getAllFolderHelp,
	stats,
	postAssignToMe,
	session,
	myNurseFolderHelps,
	acceptSupportFolderHelp,
	countMyFolders,
	otherFoldersOpened,
	loadAll,
	closeAllMyAssignedAndOpenedFolder,
	campaignsRecords,
	getNextPatientToAssign,
	savePatientMatcher,
	generalParameters,
	searchPatientsMyLab,
	getMpiPatientByMatricule,
	cancelAssignation,
	postPatientMyLab,
	getCampaignRecordsToAssign,
	getLastFoldersSupported,
	setMyNotificationSound,
	getListPreregisters,
	preregistersList,
	secretariesUserList,
	setMyTelForTvSec,
	getListExpress,
	expressList,
	tvSecMode,
}) => {
	const waiting = stats.waiting ? stats.waiting.min2 + stats.waiting.between210 + stats.waiting.more10 : 0;
	const processed = stats.processed ? stats.processed.min2 + stats.processed.between210 + stats.processed.more10 : 0;
	const secretaries = stats.secretaries ? stats.secretaries.filter((s) => s.help_nurse).length : 0;
	const [openHistoricModal, setOpenHistoricModal] = useState(false);
	const [historicFolderHelp, setHistoricFolderHelp] = useState(null);
	const [displayFolderHelpsList, setDisplayFolderHelpsList] = useState(tvSecMode === "tvsec");
	const [displayPreregistersList, setDisplayPreregisterList] = useState(tvSecMode === "preregisters");
	const [displayExpressList, setDisplayExpressList] = useState(tvSecMode === "express");
	const [patientMatcher, setPatientMatcher] = useState(null);
	const [recordCampaign, setRecordCampaign] = useState(null);
	const [campaignMpi, setCampaignMpi] = useState(null);
	const [myLabList, setMyLabList] = useState([]);
	const [myLabPagination, setMyLabPagination] = useState({ page: 1, larger: false, total: 0 });
	const [isLoadingAssignation, setIsLoadingAssignation] = useState(false);
	const [preregistersListFilters, setPreregistersListFilters] = useState({
		startDate: moment().add(-1, "days").format("YYYY-MM-DD"),
		endDate: moment().format("YYYY-MM-DD"),
		page: 1,
		count: 10,
		type: "sec",
		user: null,
	});

	const openHistoricFolderHelpModal = (folderHelp) => {
		setOpenHistoricModal(true);
		setHistoricFolderHelp(folderHelp);
	};
	const closeHistoricFolderHelpModal = () => {
		setOpenHistoricModal(false);
		setHistoricFolderHelp(null);
	};

	const searchNext = () => {
		getCampaignRecordsToAssign();
		getNextPatientToAssign().then((res) => {
			setIsLoadingAssignation(false);
			if (res && res.payload && res.payload.data) {
				if (res.payload.data.nextPatient) {
					setPatientMatcher(convertToPatient(res.payload.data.nextPatient));
					setRecordCampaign(res.payload.data.nextPatient);
					if (res.payload.data.nextPatient.cns !== "") {
						searchByMatricule(res.payload.data.nextPatient.cns, 1, false);
					} else {
						if (res.payload.data.birth_date !== "") {
							searchByMatricule(moment(res.payload.data.nextPatient.birth_date, "DD/MM/YYYY").format("YYYYMMDD"), 1, false);
						}
					}
				} else {
					closeCampaignPatientMatchingModal(false);
				}
			} else closeCampaignPatientMatchingModal(false);
		});
	};

	const pollingCallback = useCallback(async () => {
		await loadAll();

		if (tvSecMode === "tvsec") {
			await getAllFolderHelp(pagination.page, done, preregister);
		}
		if (tvSecMode === "preregisters") {
			await getListPreregisters(preregistersListFilters);
		}
		if (tvSecMode === "express") {
			await getListExpress(1, 10, "sec");
		}
	}, [tvSecMode, pagination.page, done, preregister, preregistersListFilters]);

	useSafePolling(pollingCallback, {
		delay: 15000,
		timeoutThreshold: 15000,
		enabled: true,
	});

	const closeCampaignPatientMatchingModal = (cancel = true) => {
		if (cancel) cancelAssignation(recordCampaign.id);
		setPatientMatcher(null);
		setRecordCampaign(null);
		setCampaignMpi(null);
		setMyLabList([]);
		setMyLabPagination({ page: 1, larger: false, total: 0 });
		getCampaignRecordsToAssign();
	};

	const submitCampaignPatientMatchingModal = (recordId, patient) => {
		setIsLoadingAssignation(true);
		postPatientMyLab(patient).then(async (res) => {
			if (res.payload && res.payload.data && res.payload.data.id) patient.mylab_id = res.payload.data.id;
			savePatientMatcher(recordId, patient);
			searchNext();
		});
	};

	const searchByMatricule = async (matricule, page, larger) => {
		setMyLabList([]);
		if (matricule) {
			await searchPatientsMyLab({ multiple_search: matricule }, 20, (page - 1) * 20).then((res) => {
				setMyLabList(res.payload.data.results);
				setMyLabPagination(res.payload.data.pagination);
			});

			//check mpi
			if (new RegExp("^[0-9]{13}$").test(matricule)) {
				getMpiPatientByMatricule(matricule).then(async (resMpi) => {
					if (resMpi.payload && resMpi.payload.data && resMpi.payload.data.length > 0) {
						setCampaignMpi(resMpi.payload.data[0]);
					}
				});
			} else {
				setCampaignMpi(null);
			}
		}
	};

	const convertToPatient = (record) => {
		return {
			first_name: record.first_name,
			birth_name: record.birth_name,
			last_name: record.last_name,
			gender: record.gender,
			birth_date: record.birth_date,
			mobile_phone: record.mobile_phone,
			email: record.email,
			cns: record.cns,
		};
	};

	return (
		<Grid>
			<Grid.Row key={"my-props"} style={{ paddingBottom: 0 }}>
				<MyTelForTvSecModal session={session} setMyTelForTvSec={setMyTelForTvSec} />
				<AudioNotificationModal session={session} setMyNotificationSound={setMyNotificationSound} />
				<LastFoldersSupportedModal getLastFoldersSupported={getLastFoldersSupported} countMyFolders={countMyFolders} />
			</Grid.Row>
			<Grid.Row key={"tvsecsummarystats"} style={{ paddingBottom: 0 }}>
				<Segment.Group horizontal style={{ width: "100%", textAlign: "center" }}>
					<Segment>
						<Statistic color={waiting > 7 ? "red" : waiting > 3 ? "orange" : "green"}>
							<Statistic.Value> {waiting}</Statistic.Value>
							<Statistic.Label>
								{" "}
								<div>Télésecrétariat</div>
								<div>Dossier.s en attente</div>
							</Statistic.Label>
						</Statistic>
					</Segment>
					<Segment>
						<Statistic color="green">
							<Statistic.Value> {processed}</Statistic.Value>

							<Statistic.Label>
								{" "}
								<div>Télésecrétariat</div>
								<div>Dossier.s en traitement</div>
							</Statistic.Label>
						</Statistic>
					</Segment>
					<Segment>
						<Statistic color="black">
							<Statistic.Value> {stats.preregisters}</Statistic.Value>
							<Statistic.Label>
								{" "}
								<div>Pré-inscriptions</div>
								<div>en attente</div>
							</Statistic.Label>
						</Statistic>
					</Segment>
					<Segment>
						<Statistic color="pink">
							<Statistic.Value> {stats.express}</Statistic.Value>
							<Statistic.Label>
								{" "}
								<div>Dépôts express</div>
								<div>en attente</div>
							</Statistic.Label>
						</Statistic>
					</Segment>
					<Segment>
						<Statistic color="black">
							<Statistic.Value> {secretaries}</Statistic.Value>
							<Statistic.Label>
								{" "}
								<div>Secrétaire.s</div>
								<div>connectées</div>
							</Statistic.Label>
						</Statistic>
					</Segment>
				</Segment.Group>
			</Grid.Row>
			<Grid.Row style={{ marginBottom: "2em" }}>
				<Grid.Column computer={16} tablet={16} mobile={16} style={{ padding: 0 }}>
					<div>
						{isLoading && <Loader active />}
						{stats.secretaries && stats.secretaries.filter((s) => s.need_help).length > 0 && (
							<Message
								color="red"
								icon="help"
								header={
									stats.secretaries.filter((s) => s.need_help).length > 1
										? "Urgent ! Des secrétaires ont demandé de l'aide pour encoder un dossier"
										: "Urgent ! Une secrétaire a demandé de l'aide pour encoder un dossier."
								}
								content={
									<List>
										{stats.secretaries
											.filter((s) => s.need_help)
											.map((sec) => (
												<List.Item>{sec.first_name + " " + sec.last_name}</List.Item>
											))}
									</List>
								}
							/>
						)}
						{campaignsRecords && campaignsRecords.count > 0 && (
							<>
								<Message
									warning
									icon="clipboard check"
									header={`Campagnes de prélèvement`}
									content="Des patients provenant de campagnes de prélèvement doivent être liés à un compte MyLab."
								/>
								<Segment placeholder>
									<Header icon>
										<Icon name="user secret" />
										{`Campagnes de prélèvement - ${campaignsRecords.count} assignation${
											campaignsRecords.count > 1 ? "s" : ""
										} de patients en attente`}
										{campaignsRecords.assigned > 0 &&
											` (${campaignsRecords.assigned} assignation${campaignsRecords.assigned > 1 ? "s" : ""} de patients en cours)`}
									</Header>
									<Button color="teal" onClick={() => searchNext()}>
										Assigner les patients
									</Button>
								</Segment>
								<CampaignPatientMatchingModal
									open={!!patientMatcher}
									close={closeCampaignPatientMatchingModal}
									submit={submitCampaignPatientMatchingModal}
									data={{ patient: patientMatcher, record: recordCampaign }}
									searchByMatricule={searchByMatricule}
									mpi={campaignMpi}
									mylabList={myLabList}
									mylabPagination={myLabPagination}
									generalParameters={generalParameters}
									searchNext={searchNext}
									loading={isLoadingAssignation}
								/>
							</>
						)}
						{!session.nurseHelp && (
							<Message
								info
								icon="bell"
								header="Télésecrétariat non activé"
								content="Rendez-vous disponible pour le télésecrétariat pour prendre en charge des dossiers."
							/>
						)}
						{!isLoading && (!myNurseFolderHelps || myNurseFolderHelps.length === 0) && session.nurseHelp && (
							<Segment style={{ padding: "auto" }}>
								<Header block>
									{otherFoldersOpened && otherFoldersOpened.length === 1 && (
										<div>
											<Icon name="warning" color="red" /> Le dossier {otherFoldersOpened.map((f) => f.code).join(", ")} est ouvert à votre nom, le
											système ne vous assignera pas de dossier supplémentaire. <br />
											<Button onClick={() => closeAllMyAssignedAndOpenedFolder()}>Libérer le dossier</Button>
										</div>
									)}
									{otherFoldersOpened && otherFoldersOpened.length > 1 && (
										<div>
											<Icon name="warning" color="red" /> Les dossiers {otherFoldersOpened.map((f) => f.code).join(", ")} sont ouverts à votre nom,
											aucun autre dossier ne vous sera assigné par le système. <br />
											<Button onClick={() => closeAllMyAssignedAndOpenedFolder()}>Libérer les dossiers</Button>
										</div>
									)}
									{(!otherFoldersOpened || otherFoldersOpened.length === 0) && <div>Aucun dossier ne vous est assigné actuellement.</div>}
								</Header>
							</Segment>
						)}
						{!isLoading && myNurseFolderHelps && myNurseFolderHelps.length > 0 && otherFoldersOpened && otherFoldersOpened.length > 0 && (
							<Segment style={{ padding: "auto" }}>
								<Header block>
									<Button onClick={() => closeAllMyAssignedAndOpenedFolder()}>Libérer mes dossiers</Button>
								</Header>
							</Segment>
						)}
						{!isLoading && myNurseFolderHelps && myNurseFolderHelps.filter((hf) => hf.assigned_to && hf.assigned_to.id === session.id).length > 0 && (
							<Grid
								style={{
									display: "flex",
									flex: 1,
								}}
							>
								{myNurseFolderHelps &&
									myNurseFolderHelps
										.filter((hf) => hf.assigned_to && hf.assigned_to.id === session.id)
										.slice()
										.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
										.map((f, index) => (
											<HelpFolderListItem
												key={`myNurseFolderHelps-item--${f.id}`}
												total={myNurseFolderHelps.length}
												item={index + 1}
												folderHelp={f}
												goToFolderManager={goToFolderManager}
												openHistoricFolderHelpModal={openHistoricFolderHelpModal}
												displayDone={done}
												canSee={(f.status === "ASSIGNED" || f.status === "SUPPORT") && f.assigned_to && f.assigned_to.id === session.id}
												postAssignToMe={postAssignToMe}
												support={acceptSupportFolderHelp}
											/>
										))}
							</Grid>
						)}
					</div>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column computer={16}>
					<Button.Group>
						<Button
							onClick={() => {
								if (!displayFolderHelpsList) getAllFolderHelp(1, done, preregister);
								setDisplayFolderHelpsList(!displayFolderHelpsList);
								setDisplayPreregisterList(false);
								setDisplayExpressList(false);
							}}
						>
							<Icon name="list alternate outline" />
							Liste du télésecrétariat
						</Button>
						<Button
							onClick={() => {
								if (!displayPreregistersList) getListPreregisters(preregistersListFilters);
								setDisplayPreregisterList(!displayPreregistersList);
								setDisplayFolderHelpsList(false);
								setDisplayExpressList(false);
							}}
						>
							<Icon name="list alternate outline" />
							Pré-inscriptions en attente
						</Button>
						<Button
							onClick={() => {
								if (!displayExpressList) getListExpress(1, 10, "sec");
								setDisplayPreregisterList(false);
								setDisplayFolderHelpsList(false);
								setDisplayExpressList(!displayExpressList);
							}}
						>
							<Icon name="list alternate outline" />
							Dépôts express en attente
						</Button>
					</Button.Group>
				</Grid.Column>
			</Grid.Row>
			<Grid.Row>
				<Grid.Column computer={16}></Grid.Column>
			</Grid.Row>
			{displayFolderHelpsList && (
				<>
					<Grid.Row key={"tvsecretariat"} style={_tvsecContainer(false)}>
						<Grid.Column computer={5} tablet={6} mobile={8} style={{ color: "white" }}>
							{pagination.totalCount > 0 ? `Liste des demandes d'aide (${pagination.totalCount})` : ""}
						</Grid.Column>

						<Grid.Column
							computer={11}
							tablet={10}
							mobile={8}
							style={{
								color: "white",
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<div style={{ fontSize: "0.8em", color: "#fff" }}>Pré-inscriptions</div>
							<Checkbox style={{ padding: "4px", marginRight: "10px" }} slider checked={preregister} onChange={(e) => changePreregister()} />
							<div style={{ fontSize: "0.8em", color: "#fff" }}>Dossiers terminés</div>
							<Checkbox style={{ padding: "4px", marginRight: "10px" }} slider checked={done} onChange={(e) => changeDone()} />
							{pagination.numberOfPages > 1 && (
								<span style={{ fontSize: "0.8em" }}>
									(Page: {pagination.page}/{pagination.numberOfPages})
								</span>
							)}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column computer={16} tablet={16} mobile={16} style={{ padding: 0 }}>
							<div>
								{isLoading && <Loader active />}
								{!isLoading &&
									(done
										? totalFolderHelps > 0
										: folderHelps.filter((f) => f.status !== "DONE" && f.status !== "CANCELED" && f.status !== "REASSIGNED").length > 0) && (
										<Grid
											style={{
												display: "flex",
												flex: 1,
											}}
										>
											{folderHelps &&
												folderHelps
													.slice()
													.sort((a, b) => !b.fromPreregister || moment(b.created_at).diff(moment(a.created_at)))
													.map((f, index) => (
														<HelpFolderListItem
															key={`folderhelp-item--${f.id}`}
															total={f.waitingListTotal}
															item={index + 1}
															folderHelp={f}
															goToFolderManager={goToFolderManager}
															openHistoricFolderHelpModal={openHistoricFolderHelpModal}
															displayDone={done}
															canSee={f.status === "PENDING"}
															postAssignToMe={postAssignToMe}
															support={acceptSupportFolderHelp}
														/>
													))}
											{pagination.numberOfPages > 1 && (
												<Grid.Row>
													<CustomPagination
														activePage={pagination.page}
														totalPages={pagination.numberOfPages}
														onPageChange={(e, { activePage }) => {
															getAllFolderHelp(activePage, done, preregister);
														}}
													/>
												</Grid.Row>
											)}
											<HistoricNurseHelpModal
												folderHelp={historicFolderHelp}
												open={openHistoricModal}
												closeHistoricFolderHelpModal={closeHistoricFolderHelpModal}
											/>
										</Grid>
									)}
								{!isLoading && done
									? totalFolderHelps === 0
									: folderHelps.filter((f) => f.status !== "DONE" && f.status !== "CANCELED" && f.status !== "REASSIGNED").length === 0 && (
											<Segment placeholder style={{ padding: "auto" }}>
												<Header icon>
													<Icon name="file alternate" />
													<div>Pas de demande d'aide à traiter dans le système actuellement.</div>
												</Header>
											</Segment>
									  )}
							</div>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{displayPreregistersList && preregistersList && !preregistersList.loading && preregistersList.data && (
				<>
					<Grid.Row key={"preregisters"} style={_tvsecContainer(false)}>
						<Grid.Column computer={5} tablet={6} mobile={8} style={{ color: "white" }}>
							{preregistersList.data?.count > 0 ? `Liste des pré-inscriptions en attente` : "Pas de pré-inscription en attente"}
						</Grid.Column>
						<Grid.Column computer={8} tablet={6} mobile={8} style={{ color: "white" }}>
							<div style={{ display: "flex", flexDirection: "row", alignItems: "baseline" }}>
								<Icon name="calendar alternate" style={styles.icon} />
								<span style={styles.dateText}>Du</span>
								<div style={{ width: 75 }}>
									<DatePicker
										selected={new Date(preregistersListFilters.startDate)}
										onChange={(date) => {
											setPreregistersListFilters({ ...preregistersListFilters, startDate: moment(date).format("YYYY-MM-DD"), page: 1 });
										}}
										className="datePicker"
										shouldCloseOnSelect={true}
										onFocus={(e) => (e.target.readOnly = isMobile())}
										dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
									/>
								</div>
								<span style={styles.dateText}>au</span>
								<div style={{ width: 75 }}>
									<DatePicker
										selected={new Date(preregistersListFilters.endDate)}
										onChange={(date) => {
											setPreregistersListFilters({ ...preregistersListFilters, endDate: moment(date).format("YYYY-MM-DD"), page: 1 });
										}}
										className="datePicker"
										shouldCloseOnSelect={true}
										onFocus={(e) => (e.target.readOnly = isMobile())}
										dateFormat={process.env.REACT_APP_DATE_DATEPICKER}
									/>
								</div>
								{secretariesUserList && secretariesUserList.length > 0 && (
									<div style={{ width: 250, marginLeft: 10 }}>
										<Select
											isClearable
											name="user"
											customlabel="Traité par"
											value={preregistersListFilters.user}
											options={secretariesUserList.map((i) => ({
												value: String(i.id),
												label: `${i.first_name} ${i.last_name} (${i.login})`,
											}))}
											onChange={(user) => {
												setPreregistersListFilters({ ...preregistersListFilters, user: user?.value, page: 1 });
											}}
											styles={styles.select}
											placeholder="Sélectionner une secrétaire"
										/>
									</div>
								)}
							</div>
						</Grid.Column>

						<Grid.Column
							computer={3}
							tablet={4}
							mobile={8}
							style={{
								color: "white",
								display: "flex",
								justifyContent: "flex-end",
							}}
						>
							<Label>
								<Icon name="numbered list" /> {preregistersList.data.totalCount || 0}
							</Label>
							{preregistersList.data && preregistersList.data.numberOfPages > 1 && (
								<span style={{ fontSize: "0.8em" }}>
									(Page: {preregistersList.data.page}/{preregistersList.data.numberOfPages})
								</span>
							)}
						</Grid.Column>
					</Grid.Row>
					<Grid.Row>
						<Grid.Column computer={16} tablet={16} mobile={16} style={{ padding: 0 }}>
							<div>
								{isLoading && <Loader active />}
								{preregistersList.data?.results?.length > 0 && (
									<Grid
										style={{
											display: "flex",
											flex: 1,
										}}
									>
										{preregistersList.data?.results?.length > 0 &&
											preregistersList.data.results
												.slice()
												.sort((a, b) => moment(b.created_at).diff(moment(a.created_at)))
												.map((p, index) => (
													<PreregisterListItem
														key={`preregister-item--${p.id}`}
														item={index + 1}
														preregister={p}
														goToFolderManager={goToFolderManager}
														canSee={p.folder?.status === "PENDING"}
														postAssignToMe={postAssignToMe}
														support={acceptSupportFolderHelp}
													/>
												))}
										{preregistersList.data.numberOfPages > 1 && (
											<Grid.Row>
												<CustomPagination
													activePage={preregistersList.data.page}
													totalPages={preregistersList.data.numberOfPages}
													onPageChange={(e, { activePage }) => {
														setPreregistersListFilters({ ...preregistersListFilters, page: activePage });
													}}
												/>
											</Grid.Row>
										)}
									</Grid>
								)}
								{preregistersList.data?.results?.length === 0 && (
									<Segment placeholder style={{ padding: "auto" }}>
										<Header icon>
											<Icon name="file alternate" />
											<div>Pas de pré-inscription en attente correspondant à ces critères dans le système actuellement.</div>
										</Header>
									</Segment>
								)}
							</div>
						</Grid.Column>
					</Grid.Row>
				</>
			)}
			{displayExpressList && expressList && (
				<ExpressList list={expressList} generalParameters={generalParameters} goToFolderManager={goToFolderManager} />
			)}
		</Grid>
	);
};

export default TvSecretariat;
